import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    defaultLayout: {
        
    },
    defaultLayoutHeader: {
        fontFamily: themeCommon.RobotoRegular,
        background: props => props.image && `url("${props.image}") no-repeat center center`,
        backgroundSize: 'cover !important',
        height: '222px',
        '@media (max-width: 1400px)': {
            height: '150px',
        },
        [theme.breakpoints.down('lg')]: {
            height: '150px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '100px',
        },
    },
    body1: {
        lineHeight: 'unset',
    },
    title: {
        fontSize: themeCommon.fontSize48px,
        fontFamily: themeCommon.RobotoBold,
        color: '#FFFFFF',
        marginBottom: '32px',
        '@media (max-width: 1400px)': {
            fontSize: themeCommon.fontSize30px,
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize30px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize20px,
            marginBottom: '20px',
        },
    },
    rootAvatar: {
        height: '170px',
        width: '170px',
        backgroundColor: 'white',
        border: '4px solid #0492C2',
        '@media (max-width: 1400px)': {
            height: '150px',
            width: '150px',
        },
        [theme.breakpoints.down('lg')]: {
            height: '150px',
            width: '150px',
        },
        [theme.breakpoints.down('md')]: {
            height: '130px',
            width: '130px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '100px',
            width: '100px',
            border: '3px solid #0492C2',
        },
        [theme.breakpoints.down('xs')]: {
            height: '90px',
            width: '90px',
            border: '2px solid #0492C2',
        },
    },
    titleBlue: {
        color: `${themeCommon.lightBlue} !important`,
    },
    textColorReward: {
        color: themeCommon.lightBlue,
    },
    titleProfile: {
        marginTop: '83px',
        marginBottom: '15px',
        '@media (max-width: 1400px)': {
            marginTop: '50px',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('lg')]: {
            marginTop: '50px',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '30px',
            marginBottom: '10px',
        },
    },
    description: {
        fontSize: themeCommon.fontSize24px,
        fontFamily: themeCommon.RobotoBold,
        color: '#FFFFFF',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize20px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    coin: {
        width: '100%',
        textAlign: 'center',
        marginTop: '-20px'
    }
}), {
    name: 'DefaultLayoutHeadContainer',
    index: 1,
})

export default useStyles
